import { Box, Button, Flex, Heading, Stack } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import FormikControl from "../../components/Common/Formik";
import Notification from "../../components/Common/Notification";
import { CustomDatePicker } from "../../components/CustomDatePicker/CustomDatePicker";
import BasicLayout from "../../components/Layouts/BasicLayout";
import { getCustomers } from "../../store/actions/customer/customer.action";
import { addMainOrder } from "../../store/actions/mainOrder/mainOrder.action";
import { updatePantOrder } from "../../store/actions/pantOrder/pantOrder.action";
import { updateShirtOrder } from "../../store/actions/shirtOrder/shirtOrder.action";
import { Link } from "react-router-dom";

export const MainOrder = () => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const customers = useSelector((state) => state?.customer?.customers);
  const [customerId, setCustomerId] = useState();
  const [shirtOrderIds, setShirtOrderIds] = useState([]);
  const [pantOrderIds, setPantOrderIds] = useState([]);
  const [orderDate, setOrderDate] = useState(new Date());
  const [deliveryDate, setDeliveryDate] = useState(undefined);

  const [showBillButton, setShowBillButton] = useState(false);

  const PantOrders = useMemo(() => {
    let arr = [];
    for (let i = 0; i < customers.length; i++) {
      for (let a = 0; a < customers[i]?.pantorders?.length; a++) {
        if (
          customers[i]?.pantorders[a] &&
          customers[i]?.pantorders[a]?.isAssigned === false
        ) {
          arr.push(customers[i]?.pantorders[a]);
        }
      }
    }
    return arr;
  }, [customers]);

  const ShirtOrders = useMemo(() => {
    let arr = [];
    for (let i = 0; i < customers.length; i++) {
      for (let a = 0; a < customers[i]?.shirtorders?.length; a++) {
        if (
          customers[i]?.shirtorders[a] &&
          customers[i]?.shirtorders[a]?.isAssigned === false
        ) {
          arr.push(customers[i]?.shirtorders[a]);
        }
      }
    }
    return arr;
  }, [customers]);

  let filteredShirtOrders = ShirtOrders.filter(
    (item) => item.customer === customerId?.value
  );
  let filteredPantOrders = PantOrders.filter(
    (item) => item.customer === customerId?.value
  );

  const handleSubmit = async (values) => {
    try {
      setIsSubmitting(true);
      if (shirtOrderIds.length === 0 && pantOrderIds.length === 0) {
        return Notification("", "शर्ट किंवा पँन्ट क्रमांक निवडा", "error");
      }
      values = {
        ...values,
        orderDate,
        deliveryDate,
        price: values.price.toString(),
        advance: values.advance.toString(),
        balance: values.balance.toString(),
        starchprice: values.starchprice.toString(),
        customer: customerId.value,
        shirtorders: shirtOrderIds.map((item) => item.value),
        pantorders: pantOrderIds.map((item) => item.value),
      };
      const resp = await dispatch(addMainOrder(values));
      if (values?.shirtorders && values?.shirtorders?.length) {
        for (let i = 0; i < values.shirtorders.length; i++) {
          await dispatch(
            updateShirtOrder(values.shirtorders[i], { isAssigned: true })
          );
        }
      }
      if (values?.pantorders && values?.pantorders?.length) {
        for (let i = 0; i < values.pantorders.length; i++) {
          await dispatch(
            updatePantOrder(values.pantorders[i], { isAssigned: true })
          );
        }
      }
      setShowBillButton(resp.id);
      setShirtOrderIds([]);
      setPantOrderIds([]);
      setIsSubmitting(false);
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message || "Something went wrong";
      setIsSubmitting(false);
      return Notification("", errorMessage, "error");
    }
  };

  useEffect(() => {
    dispatch(getCustomers());
  }, [dispatch]);

  const defaultValues = {
    price: "",
    advance: "",
    balance: "",
    starchprice: "",
  };
  return (
    <BasicLayout>
      <Flex minH="50vh" bg="blackAlpha.300">
        <Formik
          enableReinitialize
          initialValues={defaultValues}
          onSubmit={handleSubmit}
        >
          {(props) => (
            <Form style={{ width: "100vw" }}>
              <Box
                w="80vw"
                margin="100px auto"
                p={10}
                boxShadow="dark-lg"
                borderRadius="10px"
              >
                <Stack spacing="10">
                  <Box w="48%">
                    <Heading as="h5" fontSize="28px">
                      ग्राहक
                    </Heading>
                    <Select
                      value={customerId}
                      isSearchable
                      placeholder="ग्राहक क्रमांक"
                      options={customers.map((item) => ({
                        label: item.name,
                        value: item.id,
                      }))}
                      onChange={(e) => {
                        setCustomerId(e);
                      }}
                    />
                  </Box>
                  <Flex justifyContent="space-between">
                    <Box w="48%">
                      <Heading as="h5" fontSize="28px">
                        पँन्ट ऑर्डर क्रमांक
                      </Heading>
                      <Select
                        value={pantOrderIds}
                        isSearchable
                        isMulti
                        closeMenuOnSelect={false}
                        name="pantorders"
                        placeholder="क्रमांक"
                        options={filteredPantOrders.map((item) => ({
                          label: item.id,
                          value: item.id,
                        }))}
                        onChange={(e) => setPantOrderIds(e)}
                      />
                    </Box>
                    <Box w="48%">
                      <Heading as="h5" fontSize="28px">
                        शर्ट ऑर्डर क्रमांक
                      </Heading>
                      <Select
                        value={shirtOrderIds}
                        isMulti
                        closeMenuOnSelect={false}
                        name="shirtorders"
                        isSearchable
                        placeholder="क्रमांक"
                        options={filteredShirtOrders.map((item) => ({
                          label: item.id,
                          value: item.id,
                        }))}
                        onChange={(e) => setShirtOrderIds(e)}
                      />
                    </Box>
                  </Flex>
                  <Flex justify="space-between">
                    <Box w="48%">
                      <Heading as="h5" fontSize="28px">
                        ऑर्डर डेट
                      </Heading>
                      <CustomDatePicker
                        date={orderDate}
                        setDate={setOrderDate}
                      />
                    </Box>

                    <Box w="48%">
                      <Heading as="h5" fontSize="28px">
                        डिलेव्हरी डेट
                      </Heading>
                      <CustomDatePicker
                        date={deliveryDate}
                        setDate={setDeliveryDate}
                      />
                    </Box>
                  </Flex>
                  {
                    (props.values.balance =
                      props.values.price - props.values.advance)
                  }
                  <Flex justifyContent="space-between">
                    <Box>
                      <FormikControl
                        fontSize="28px"
                        control="chakrainput"
                        label="पूर्ण किंमत"
                        isRequired={true}
                        name="price"
                        type="number"
                      />
                    </Box>
                    <Box>
                      <FormikControl
                        fontSize="28px"
                        control="chakrainput"
                        isRequired={true}
                        label="ऍडव्हान्स"
                        name="advance"
                        type="number"
                      />
                    </Box>
                    <Box>
                      <FormikControl
                        isDisabled={true}
                        fontSize="28px"
                        control="chakrainput"
                        label="बॅलन्स"
                        name="balance"
                        type="number"
                      />
                    </Box>
                    <Box>
                      <FormikControl
                        fontSize="28px"
                        control="chakrainput"
                        label="स्टार्च किंमत"
                        name="starchprice"
                        type="number"
                      />
                    </Box>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <Button
                      type="submit"
                      colorScheme="facebook"
                      className="mainorder-btn"
                      isLoading={isSubmitting}
                    >
                      नोंदवा
                    </Button>
                    {showBillButton === false ? null : (
                      <Link to={`/print/${showBillButton}`}>
                        <Button
                          colorScheme="facebook"
                          className="mainorder-btn"
                        >
                          बिल पहा
                        </Button>
                      </Link>
                    )}
                  </Flex>
                </Stack>
              </Box>
            </Form>
          )}
        </Formik>
      </Flex>
    </BasicLayout>
  );
};
